module.exports = __webpack_public_path__ + "static/note-links-do-2a7382875b88e5ec123a4154120e37b8.png";